import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_PUBLIC_API_BASE_URL || "/";

const publicApi = axios.create({
  baseURL: API_BASE_URL,
});

const buildFormBody = (payload) => {
  const body = new URLSearchParams();

  Object.entries(payload).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      body.append(key, value);
    }
  });

  return body;
};

const getErrorMessage = (error, fallback) => {
  const response = error?.response?.data;

  if (response?.message) {
    return response.message;
  }

  return fallback;
};

export const normalizeIndianMobile = (value) => {
  const digits = String(value || "").replace(/\D/g, "");

  if (digits.length === 12 && digits.startsWith("91")) {
    return digits.slice(2);
  }

  return digits;
};

export const submitContactForm = async (form) => {
  try {
    const { data } = await publicApi.post(
      "public/contact-form/submit/",
      buildFormBody({
        full_name: form.name.trim(),
        mobile_number: normalizeIndianMobile(form.phone),
        email_address: form.email.trim(),
        subject: form.subject,
        message: form.message.trim(),
      })
    );

    return data;
  } catch (error) {
    throw {
      message: getErrorMessage(
        error,
        "We could not submit your enquiry right now. Please try again."
      ),
      errors: error?.response?.data?.errors || {},
    };
  }
};

export const submitPartnerLead = async (form) => {
  try {
    const { data } = await publicApi.post(
      "public/partner-lead/submit/",
      buildFormBody({
        full_name: form.name.trim(),
        shop_business_name: form.shop.trim(),
        email_address: form.email.trim(),
        mobile_number: normalizeIndianMobile(form.phone),
        city: form.city.trim(),
        state: form.state.trim(),
        business_type: form.type,
        additional_message: form.notes.trim(),
      })
    );

    return data;
  } catch (error) {
    throw {
      message: getErrorMessage(
        error,
        "We could not submit your partner application right now. Please try again."
      ),
      errors: error?.response?.data?.errors || {},
    };
  }
};
